
import { getCurrentUser } from "../../lib/auth_base/auth-service";
import useFetchCategories from "../../lib/hooks/use-fetch-categories";
import CreateProduct from "./ui/create-product";


///
export default function NewProduct() {
  const user = getCurrentUser();
  const {categories} = useFetchCategories();

  return (
    <CreateProduct
      categories={categories}
    />
  );
}
